import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TableHeader from './Header'
import TableRow from './Row'
import TableOptions from './TableOptions'

interface Props {
  shiftTemplate: ShiftManagementTemplateFragment
}

const ShiftTemplateTable = ({ shiftTemplate }: Props) => {
  const activeWeeks = shiftTemplate.templateWeeks.filter((week) => !week.archived)

  return (
    <Box paddingBottom="s24">
      <Table autoLayout options={() => <TableOptions shiftTemplate={shiftTemplate} />}>
        <TableHeader />
        <Table.Body>
          {activeWeeks.map((week) => (
            <TableRow key={week.id} shiftConfigs={week.shiftConfigurations} templateWeek={week} />
          ))}
        </Table.Body>
      </Table>
    </Box>
  )
}

export default observer(ShiftTemplateTable)
